import React from "react";
import { Modal, Avatar, Spin } from "antd";
import moment from "moment";

const CommentsModal = ({
  visible,
  onClose,
  comments = [],
  loading = false,
  title = "Comments"
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      bodyStyle={{ maxHeight: '400px', overflowY: 'auto' }}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spin />
        </div>
      ) : comments.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
          No Comments Found
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {comments.slice().reverse().map((comment, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #D9D9D9",
                borderRadius: "8px",
                padding: "8px 12px",
                backgroundColor: "#fff"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                <Avatar
                  size={18}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#A5D6A7" : "#BBDEFB",
                    color: "#101820",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {typeof comment.user === 'string' ? comment.user.charAt(0) : (comment.user?.firstName?.charAt(0) || "U")}
                </Avatar>
                <span style={{ fontSize: "12px", fontWeight: "600", color: "#101820" }}>
                  {typeof comment.user === 'string' ? comment.user : `${comment.user?.firstName || ""} ${comment.user?.lastName || ""}`.trim() || "Unknown User"}
                </span>
                <span style={{ fontSize: "12px", color: "#101820" }}>
                  - {comment.date || (comment.createdAt ? moment(comment.createdAt).format("YYYY/MM/DD HH:mm") : "")}
                </span>
              </div>
              <div style={{ fontSize: "14px", color: "#383838", paddingTop: "8px" }}>
                {comment.text || comment.content}
              </div>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default CommentsModal;
